export enum EdoQuestionTypeEnum {
  FREE_TEXT = "FREE_TEXT",
  TRUE_FALSE = "TRUE_FALSE",
  SINGLE_CHOICE = "SINGLE_CHOICE",
  MULTIPLE_CHOICE = "MULTIPLE_CHOICE",
  FILL_BLANK = "FILL_BLANK",
}
